export class FieldOption {
  constructor(
    public text: string,
    public value: string | number,
    public group?: string
  ) {}
}
